import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import VendorAuthActivitySection from '../../../components/MasterAdmin/VendorAuthActivitySection';

const VENDOR_KIND_LABELS: Record<string, string> = {
  ambulance: 'Ambulance agency',
  hospital: 'Hospital',
  'medical-store': 'Medical store',
  'blood-bank': 'Blood bank',
  'doctor-clinic': 'Doctor / clinic',
  'diagnostic-center': 'Diagnostic center',
  product: 'Product partner',
};

const VendorLoginActivityPage: React.FC = () => {
  const navigate = useNavigate();
  const { vendorKind, vendorId } = useParams<{ vendorKind: string; vendorId: string }>();

  const backPath =
    vendorKind && vendorId ? `/vendors/${vendorKind}/${vendorId}` : '/vendors';
  const kindLabel =
    (vendorKind && VENDOR_KIND_LABELS[vendorKind]) ||
    (vendorKind ? vendorKind.replace(/-/g, ' ') : 'Vendor');

  return (
    <div className="mx-auto w-full min-w-0 max-w-5xl px-0.5">
      <button
        type="button"
        onClick={() => navigate(backPath)}
        className="mb-4 inline-flex items-center gap-1.5 text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
      >
        <ArrowLeftIcon className="h-4 w-4 shrink-0" />
        Back
      </button>
      <p className="mb-4 text-xs text-gray-500 dark:text-gray-400">{kindLabel}</p>
      <VendorAuthActivitySection vendorId={vendorId} showSectionTitle={false} />
    </div>
  );
};

export default VendorLoginActivityPage;
